const COMMON_STYLE_ID = "common-footer-license-style";

const css = `
.footer-license {
  position: static;
  width: 100%;
  flex: 0 0 auto;
  margin-top: auto;
  padding: 0 20px 10px;
  direction: rtl;
  background-color: transparent;
  box-sizing: border-box;
}

.footer-license__inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 36px;
  padding: 8px 16px;
  border: 1px solid #9aa2ac;
  border-radius: 32px;
  background-color: var(--hover-background-color, #f5f5f5);
  color: #9aa2ac;
  box-sizing: border-box;
}

.footer-license__links {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex: 0 0 auto;
  font-size: 0.8rem;
  white-space: nowrap;
}

.footer-license__link {
  color: #9aa2ac;
  text-decoration: none;
  cursor: pointer;
}

.footer-license__link:hover {
  text-decoration: underline;
}

.footer-license__separator {
  color: #9aa2ac;
}

.footer-license__sinarem,
.footer-license__sinarem-separator {
  display: inline;
}

.footer-license__text {
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  color: #9aa2ac;
  font-size: 0.8rem;
  text-align: left;
}

body.dark-theme .footer-license__inner {
  background-color: var(--background-color, #1f2937);
  border-color: rgba(var(--text-color-secondary-rgb), 0.45);
}

body.dark-theme .footer-license__text,
body.dark-theme .footer-license__link,
body.dark-theme .footer-license__separator {
  color: var(--text-color-secondary, #9aa2ac);
}

@media only screen and (max-width: 768px) {
  .footer-license {
    padding: 0 20px 10px;
  }

  .footer-license__inner {
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
    min-height: 0;
    padding: 7px 10px;
    border-radius: 32px;
  }

  .footer-license__links {
    flex: 0 0 auto;
    font-size: 0.62rem;
  }

  .footer-license__text {
    width: auto;
    font-size: 0.42rem;
    letter-spacing: -0.08px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .footer-license__sinarem,
  .footer-license__sinarem-separator {
    display: none;
  }
}

@media only screen and (max-width: 380px) {
  .footer-license__inner {
    gap: 6px;
    padding-inline: 8px;
  }

  .footer-license__links {
    gap: 5px;
    font-size: 0.56rem;
  }

  .footer-license__text {
    font-size: 0.38rem;
  }
}
`;

if (typeof document !== "undefined" && !document.getElementById(COMMON_STYLE_ID)) {
  const style = document.createElement("style");
  style.id = COMMON_STYLE_ID;
  style.textContent = css;
  document.head.appendChild(style);
}
